import React from "react";
import Shape from "../../images/gq-shap.svg";
import Shape2 from "../../images/gq-shap-2.svg";
import { useLanguage } from '../../context/LanguageContext';

const GetquateSection = (props) => {
    const { t } = useLanguage();

    return (
        <section className="get-quate-section-s2 section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12">
                        <div className="content">
                            <div className="section-title">
                                <h2>{t('getquate.heading1')}<span> {t('getquate.heading2')}</span> {t('getquate.heading3')} <span>{t('getquate.heading4')}</span> {t('getquate.heading5')}</h2>
                                <p>{t('getquate.p')}</p>
                            </div>
                            <div className="item-wrap">
                                <ul>
                                    <li><i className="ti-check"></i>{t('getquate.li1')}</li>
                                    <li><i className="ti-check"></i>{t('getquate.li2')}</li>
                                    <li><i className="ti-check"></i>{t('getquate.li3')}</li>
                                </ul>
                            </div>
                            <ul className="buttom-item">
                                <li>
                                    <div className="text">
                                        <span>{t('getquate.badge')}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12"></div>
                </div>
            </div>
            <div className="shape">
                <img src={Shape} alt="Kedi Dekoratif İkon" />
            </div>
            <div className="shape2">
                <img src={Shape2} alt="Köpek Dekoratif İkon" />
            </div>
        </section>
    )
}
export default GetquateSection;
